import { Contracting_List } from "data/endpoints";
import DataGridState from "features/shared/components/dataGrid/DataGridState";
import React from "react";
import ContractingSimplifiedDTO from "features/contracting/dtos/ContractingSimplifiedDTO";
import ContractingSimplified from "features/contracting/components/ContractingSimplified";
import ContractingSimplifiedHeader from "features/contracting//components/ContractingSimplifiedHeader";
import { loadDataFilterConfig } from "features/shared/helpers/modules";
import AlertWithButton from "features/shared/alerts/components/AlertWithButton";
import RolesChecker from "features/customer/components/RolesChecker";
import { useTranslation } from "react-i18next";
import AddContractingButton from "features/contracting/components/AddContractingButton";
import { useContractingAdd } from "../hooks/useContractingAdd";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import CustomerState from "infrastructure/store/customer/CustomerState";

const contractingsDataFilterJson = loadDataFilterConfig(
  "contractingsDataFilter"
);
const pageSize = 10;

type Props = {
  forAdminUse?: boolean;
};

const ContractingsSection = ({ forAdminUse = false }: Props) => {
  // translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // store
  const customer = useSelector<IAppState, CustomerState>(
    (store) => store.customer
  ).customer;

  // add contracting hook
  const { onAddClick } = useContractingAdd("/contracting/add");

  // helpers
  const getQueryParams = (): URLSearchParams => {
    let urlParams = new URLSearchParams();

    if (forAdminUse) {
      urlParams.set("ForAdminUse", forAdminUse.toString());
    } else {
      urlParams.set("CustomerId", customer.customerId!);
    }

    return urlParams;
  };

  // sub-renders
  const renderItem = (contracting: ContractingSimplifiedDTO) => {
    return (
      <ContractingSimplified
        contracting={contracting}
        forAdminUse={forAdminUse}
      />
    );
  };

  const renderHeader = () => {
    return <ContractingSimplifiedHeader hideCustomerCol={!forAdminUse} />;
  };

  const renderNoContentAlert = () => {
    return (
      <AlertWithButton
        alertInfo={tLabels("contractingsSection.contractingsNotFound")}
        renderButton={!forAdminUse ? renderAddContractingBtn : undefined}
      />
    );
  };

  const renderAddContractingBtn = (): JSX.Element => {
    return (
      <RolesChecker enabledRoles="Contributor">
        <AddContractingButton onAddClick={onAddClick} />
      </RolesChecker>
    );
  };

  // render
  return (
    <DataGridState
      url={Contracting_List}
      pageSize={pageSize}
      filterJson={forAdminUse ? contractingsDataFilterJson : undefined}
      renderItem={renderItem}
      renderHeader={renderHeader}
      noFilterQueryParams={getQueryParams()}
      renderNoContent={renderNoContentAlert}
      renderGridHeaderBtns={renderAddContractingBtn}
    />
  );
};

export default ContractingsSection;
